/**
 * Shared unit options for estimate line items, “New service”, and Pricing-related UIs.
 * `value` is what we store and send to the API; `label` is what we show in dropdowns.
 */
export const ESTIMATE_UNIT_OPTIONS: { value: string; label: string }[] = [
  { value: "unit", label: "unit (general)" },
  { value: "each", label: "each" },
  { value: "hour", label: "hour" },
  { value: "day", label: "day" },
  { value: "week", label: "week" },
  { value: "month", label: "month" },
  { value: "sqft", label: "sq ft" },
  { value: "sq m", label: "sq m" },
  { value: "linear ft", label: "linear ft" },
  { value: "linear m", label: "linear m" },
  { value: "ft", label: "ft" },
  { value: "yard", label: "yard" },
  { value: "cubic yard", label: "cubic yard" },
  { value: "cubic ft", label: "cubic ft" },
  { value: "gallon", label: "gallon" },
  { value: "liter", label: "liter" },
  { value: "lb", label: "lb" },
  { value: "ton", label: "ton" },
  { value: "kg", label: "kg" },
  { value: "piece", label: "piece" },
  { value: "set", label: "set" },
  { value: "lot", label: "lot" },
  { value: "room", label: "room" },
  { value: "opening", label: "opening" },
  { value: "job", label: "job" },
  { value: "visit", label: "visit" },
];

/** Map unit → API labor_method hint (best-effort). */
export function laborMethodForEstimateUnit(unit: string): string {
  const u = unit.toLowerCase();
  if (u === "hour" || u.includes("day") || u.includes("week") || u.includes("month")) return "by_hour";
  if (u.includes("sq") || u === "sqft" || u.includes("sq m")) return "by_area";
  if (u.includes("linear") || u === "ft" || u.includes("yard") || u.includes("meter")) return "by_length";
  if (u.includes("cubic") || u.includes("gallon") || u.includes("liter")) return "by_volume";
  if (u.includes("lb") || u.includes("kg") || u.includes("ton")) return "by_weight";
  return "by_unit";
}

/** Include a legacy/custom unit value in the dropdown if it is not in the catalog. */
export function mergeEstimateUnitOptions(current?: string | null): { value: string; label: string }[] {
  const opts = [...ESTIMATE_UNIT_OPTIONS];
  const cur = (current || "").trim();
  if (cur && !opts.some((o) => o.value === cur)) {
    return [{ value: cur, label: cur }, ...opts];
  }
  return opts;
}

export function formatEstimateUnitLabel(value?: string | null): string {
  const v = (value || "").trim();
  if (!v) return "unit";
  return ESTIMATE_UNIT_OPTIONS.find((o) => o.value === v)?.label || v;
}
